import React from 'react';
import { Container, Box, CircularProgress, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { getUserDetails } from '../../utils';
import { useQueryGetTotalUsers } from '../../hooks/react-query/useData';
import { AnalyticsDashboard } from '../../components/analytics';

export default function PrincipalDashboard() {
  const navigate = useNavigate();
  const userDetails = getUserDetails();
  const userRole = userDetails?.role?.toUpperCase();

  const { data, isFetching: isLoading } = useQueryGetTotalUsers(
    userDetails?.token, 
    navigate, 
    userRole
  );

  return (
    <>
      <Helmet>
        <title>Edifying Teachers | Principal Dashboard</title>
      </Helmet>
      <Container maxWidth="xl" sx={{ p: '0 !important' }}>
        <Box sx={{ mb: 3 }}>
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <AnalyticsDashboard data={data} isLoading={isLoading} />
              </Grid>
            </Grid>
          )}
        </Box>
      </Container>
    </>
  );
}

